import { render, staticRenderFns } from "./ProjectCardPlaceholder.vue?vue&type=template&id=72937510"
import script from "./ProjectCardPlaceholder.vue?vue&type=script&lang=ts"
export * from "./ProjectCardPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports